import { AlbumsApi } from './methods/AlbumsApi';
import { ArtistsApi } from './methods/ArtistsApi';
import { DmcaApi } from './methods/DmcaApi';
import { PlaylistsApi } from './methods/PlaylistsApi';
import { StatApi } from './methods/StatApi';
import { SubscriptionsApi } from './methods/SubscriptionsApi';
import { TracksApi } from './methods/TracksApi';
import { UsersApi } from './methods/UsersApi';

import { IHttpTransport } from '@interfaces';

export class Api {

	static transport: IHttpTransport;

	static stat: StatApi = new StatApi(Api);

	static albums: AlbumsApi = new AlbumsApi(Api);
	static artists: ArtistsApi = new ArtistsApi(Api);
	static playlists: PlaylistsApi = new PlaylistsApi(Api);
	static subscriptions: SubscriptionsApi = new SubscriptionsApi(Api);
	static tracks: TracksApi = new TracksApi(Api);
	static users: UsersApi = new UsersApi(Api);
	static dmca: DmcaApi = new DmcaApi(Api);

	static setTransport(transport: IHttpTransport) {
		this.transport = transport;
	}

	static getTransport(): IHttpTransport {
		return this.transport;
	}

}

// if (!IS_SSR) {
// 	window.MoosicApi = Api;
// }
